// Bloqueio de download de imagens via clique direito / arrastar - Buá BH
// Isso dificulta o download casual, mas não impede 100% (ex: ferramentas de
// desenvolvedor do navegador ainda conseguem acessar a imagem).

document.addEventListener('contextmenu', function (e) {
  if (e.target.tagName === 'IMG') {
    e.preventDefault();
  }
});

document.addEventListener('dragstart', function (e) {
  if (e.target.tagName === 'IMG') {
    e.preventDefault();
  }
});